module.exports = __webpack_public_path__ + "assets/img/address-border.34ce1f51.png";